import React from "react";
import styles from "../Boombassador.module.scss"

const BoombassadorAccept = ({onAgree}) => {
  return (
    <div className={styles.dialogContent}>
      <h2>You’ve been chosen to be a BoomBassador at your school well done! 🎉</h2>
      <h2>This is an important job where you help record reading for other children. Before you begin, please agree to the BoomBassador promise:</h2>

      <p>✔️ Be honest – I will only record reading that has really been done.</p>
      <p>📚 Encourage others – I will help my classmates enjoy reading and remind them to record their books.</p>
      <p>🧠 Be sensible – I will take care when using BoomReader and follow the teacher’s instructions.</p>
      <p>🤝 Be kind and fair – I will treat everyone’s reading equally and with respect.</p>
      <p>🕒 Be reliable – I will do my BoomBassador job when it’s my turn and not forget.</p>
      <p>🌈 Be proud – I will help make reading fun and exciting in my school!</p>

      <button className={styles.agreeButton} onClick={onAgree}>I Agree</button>
    </div>
  );
};

export default BoombassadorAccept;
